import React, { Component } from 'react';
import { Card, CardBody, Col, Container, Row, Button } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import * as myConstClass from '../../../constant.js';
import 'font-awesome/css/font-awesome.min.css';
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";

const { SearchBar } = Search;
const tableColumns = [
  {
    dataField: "sr_no",
    text: "#",
    sort: true,
    headerStyle: { width: "5%" }
  },
  {
    dataField: "user_id",
    text: "User Id",
    sort: true,
    headerStyle: { width: "5%" }
  },
  {
    dataField: "user_full_name",
    text: "User Full Name",
    sort: true,
    headerStyle: { width: "20%" }
  },
  {
    dataField: "mobile_no",
    text: "Mobile No",
    sort: true,
    headerStyle: { width: "10%" }
  },
  {
    dataField: "otp",
    text: "OTP",
    sort: true,
    headerStyle: { width: "5%" }
  },
  {
    dataField: "purpose_title",
    text: "Purpose ",
    sort: true,
    headerStyle: { width: "5%" }
  },
  {
    dataField: "created_on",
    text: "Date/Time",
    sort: true,
    headerStyle: { width: "10%" }
  },
  {
    dataField: "action",
    text: "Action",
    sort: true,
    headerStyle: { width: "5%" }
  },
];
const image = `${process.env.PUBLIC_URL}/img/map-location.png`;
class Otp_list extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: [],
    }
    this.flag = 0;
    this.customLabels = {
      first: '<<',
      last: '>>',
      prev: '<',
      next: '>',
      show: 'Display',
      entries: 'rows',
      noResults: 'There is no data to be displayed',
    };
  }

  onSortFunction = {
    date(columnValue) {
      // Convert the string date format to UTC timestamp
      // So the table could sort it by number instead of by string
      return moment(columnValue, 'Do MMMM YYYY').valueOf();
    },
  };

  componentDidMount() {
    fetch(myConstClass.BASE_URL + '/user/getOtp')
      .then(response => response.json())
      .then(response => {
        let key = 1;
        response.forEach(element => {
          var id = element.id;
          element.sr_no = key;
          var user_full_name = "-";
          if (element.first_name != null || element.first_name != "") {
            user_full_name = element.first_name;
          }
          if (element.last_name != null || element.last_name != "") {
            user_full_name += " " + element.last_name;
          }
          if (element.user_id == 0) {
            user_full_name = "-";
          }
          element.user_full_name = user_full_name;
          var purpose_title = "";
          if (element.purpose == "1") {
            purpose_title = "Login";
          }
          if (element.purpose == "2") {
            purpose_title = "OTP";
          }
          if (element.purpose == "3") {
            purpose_title = "Mpin";
          }
          if (element.purpose == "4") {
            purpose_title = "QR Code";
          }
          element.purpose_title = purpose_title;
          element.action = <div><i id={id} className="fa fa-eye ptr_css" onClick={() => this.viewOtp(id, element.user_id)}></i></div>;
          key++;
        });
        this.setState({ formData: response })
      })
      .catch(err => console.log(err))
    if (!localStorage.getItem('session_id')) {
      console.log('History:', this.props);
      this.props.history.push('/log_in');
    }
  }

  viewOtp(e, user_id) {
    this.props.history.push('/forms/view_otp/' + e + '/' + user_id);
  }

  render() {
    const { formData } = this.state;
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">OTP</h3>
            <div style={{ float: 'right' }}></div>
          </Col>
          <ToastContainer enableMultiContainer containerId={'A'} position={toast.POSITION.BOTTOM_LEFT} />
          <ToastContainer enableMultiContainer containerId={'B'} position={toast.POSITION.TOP_RIGHT} />
        </Row>
        <Row>
          <Col md={12} lg={12}>
            <Card>
              <ToolkitProvider
                keyField="name"
                data={this.state.formData}
                columns={tableColumns}
                exportCSV
                search
              >
                {props => (
                  <div>
                    <CardBody>
                      <SearchBar {...props.searchProps} />
                      <BootstrapTable
                        {...props.baseProps}
                        bootstrap4
                        bordered={false}
                        pagination={paginationFactory({
                          // sizePerPage: 25,
                          sizePerPage: 10,
                          sizePerPageList: [5, 10, 25, 50]
                        })}
                      />
                    </CardBody>
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </Col>
        </Row>
      </Container>)
  }
}

export default withTranslation('common')(Otp_list);
